(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
  class HeroVideoSequence extends HTMLElement {
    constructor() {
      super();
      this.clips = Array.from(this.querySelectorAll('.hero-video__clip'));
      this.active = 0;
    }

    connectedCallback() {
      if (this.clips.length === 0) return;
      if (this.shouldSkipVideo()) return this.disableSequence();
      this.bindEnded();
      if (document.readyState === 'complete') {
        this.playClip(0);
      } else {
        window.addEventListener('load', () => this.playClip(0), { once: true });
      }
    }

    shouldSkipVideo() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return true;
      const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (!conn) return false;
      if (conn.saveData === true) return true;
      if (conn.effectiveType === 'slow-2g' || conn.effectiveType === '2g') return true;
      return false;
    }

    disableSequence() {
      this.clips.forEach((clip) => {
        clip.classList.remove('is-active');
        clip.querySelectorAll('video').forEach((v) => {
          v.removeAttribute('autoplay');
          v.preload = 'none';
          v.pause();
        });
      });
      this.style.display = 'none';
    }

    activeVideo(clip) {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const role = isMobile && clip.dataset.hasMobile === 'true' ? 'mobile' : 'desktop';
      return clip.querySelector(`video[data-clip-role="${role}"]`) || clip.querySelector('video');
    }

    bindEnded() {
      this.clips.forEach((clip) => {
        clip.querySelectorAll('video').forEach((video) => {
          video.addEventListener('ended', () => this.advance());
          video.addEventListener('error', () => this.advance());
        });
      });
    }

    playClip(index) {
      const total = this.clips.length;
      if (total === 0) return;
      const next = ((index % total) + total) % total;
      this.clips.forEach((clip, i) => clip.classList.toggle('is-active', i === next));
      this.active = next;
      const video = this.activeVideo(this.clips[next]);
      if (!video) return;
      video.currentTime = 0;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => this.disableSequence());
      }
      this.preloadNext();
    }

    preloadNext() {
      const total = this.clips.length;
      if (total < 2) return;
      const nextIndex = (this.active + 1) % total;
      const video = this.activeVideo(this.clips[nextIndex]);
      if (video && video.preload !== 'auto') video.preload = 'auto';
    }

    advance() {
      const total = this.clips.length;
      if (total === 0) return;
      this.playClip(this.active + 1);
    }
  }

  if (!customElements.get('hero-video-sequence')) {
    customElements.define('hero-video-sequence', HeroVideoSequence);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  class ReviewsCarousel extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('.reviews-carousel__track');
      this.slides = Array.from(this.querySelectorAll('.reviews-carousel__slide'));
      this.dots = Array.from(this.querySelectorAll('.reviews-carousel__dot'));
      this.activeIndex = 0;
      this.autoplayTimer = null;
    }

    connectedCallback() {
      if (!this.track || this.slides.length < 1) return;
      if (this.dataset.randomise === 'true' && this.slides.length > 1) this.shuffle();
      this.bindDots();
      this.bindScroll();
      this.bindHover();
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.dataset.autoplay === 'true' && this.slides.length > 1 && !reducedMotion) this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    shuffle() {
      const items = Array.from(this.track.children);
      for (let i = items.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        if (i !== j) this.track.insertBefore(items[j], items[i].nextSibling);
      }
      this.slides = Array.from(this.querySelectorAll('.reviews-carousel__slide'));
    }

    bindDots() {
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const target = parseInt(dot.dataset.index, 10);
          this.goTo(target);
        });
      });
    }

    bindScroll() {
      let scrollTimer = null;
      this.track.addEventListener('scroll', () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => this.syncFromScroll(), 80);
      });
    }

    bindHover() {
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => {
        if (this.dataset.autoplay === 'true' && this.slides.length > 1) this.startAutoplay();
      });
      this.addEventListener('focusin', () => this.stopAutoplay());
    }

    syncFromScroll() {
      const slideWidth = this.track.clientWidth;
      if (slideWidth === 0) return;
      const index = Math.round(this.track.scrollLeft / slideWidth);
      if (index !== this.activeIndex) this.setActive(index);
    }

    goTo(index) {
      const total = this.slides.length;
      if (total === 0) return;
      const wrapped = ((index % total) + total) % total;
      this.setActive(wrapped);
      const slideWidth = this.track.clientWidth;
      this.track.scrollTo({ left: wrapped * slideWidth, behavior: 'smooth' });
    }

    setActive(index) {
      this.activeIndex = index;
      this.dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    startAutoplay() {
      this.stopAutoplay();
      const interval = parseInt(this.dataset.autoplayInterval, 10) || 6000;
      this.autoplayTimer = setInterval(() => this.goTo(this.activeIndex + 1), interval);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  if (!customElements.get('reviews-carousel')) {
    customElements.define('reviews-carousel', ReviewsCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
